import { FormattedMessage } from "react-intl";
const UnlimitedUsers = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.unlimitedUsers.content.body"
                    defaultMessage="Connect the dots across your teams by inviting as many people as you need, anywhere from 11 to 50,000 users."
                />
            </p>
        </div>
    );
};
export default UnlimitedUsers;
